<template>
    <div>
        <div class="row mt-5">
            <div class="col-sm-10">
                 <div class="row">
                 <div class="col-sm-2 pt-2 pr-0">Download Template: </div>
                 <div class="col-sm-10 ml-0 pl-0" v-if="contract_type !='Add'"><b-button :href="$api_url+'/contract/template'" @click="downloadImportTemplate" class="btn btn-primary rounded p-2 pr-4 pl-4 mr-4 float-left" ><b-icon icon="code-slash" ></b-icon> All Employees</b-button> <b-button :href="$api_url+'/contract/template/active'" @click="downloadImportTemplate" class="btn btn-primary rounded p-2 pr-4 pl-4 mr-4 float-left" ><b-icon icon="code-slash" ></b-icon> Template for active contract</b-button><b-button :href="$api_url+'/contract/template/inactive'" @click="downloadImportTemplate" class="btn btn-primary rounded p-2 pr-4 pl-4 float-left" ><b-icon icon="code-slash" ></b-icon> Template for inactive contract</b-button></div>

                 <div class="col-sm-3 ml-0 pl-0" v-if="contract_type =='Add'"><b-button :href="$api_url+'/contract/template/new'" @click="downloadImportTemplate" class="btn btn-primary rounded p-2 pr-4 pl-4  float-left" ><b-icon icon="code-slash" ></b-icon> New Employees</b-button></div>
                 </div>
            </div>
            <div class="col-sm-2">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>
        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />
            <div v-if='errormsg'>
                <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                <ul class="list-group ">
                    <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                </ul>
            </div>
        </b-overlay>
  </div>
</template>
<script>

    export default{
        mounted() {
            this.upload_url = this.$api_url+"/contract/import";
        },
        props: ['contract_type'],
        data(){
            return {
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                upload_url : '',
                process_url : '',
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                uploaded_file_data : this.$api_url+"/contract/import/processdata",
                imptimeout: false,
            }
        },
        methods:{

            downloadImportTemplate:function(iset=true)
            {
                var ovTimeOut;
                this.showoverlay = true;
                var curr_obj = this;
                if(!this.imptimeout && iset){
                   document.cookie = "import_template=st; expires=Thu, 18 Dec 2013 12:00:00 UTC";
                   this.imptimeout = true;
                }

                var dt = document.cookie.indexOf('import_template');
                //alert(dt);
                if(dt<0){
                //alert('showing');
                ovTimeOut = setTimeout(function(){
                curr_obj.downloadImportTemplate(false);
                }, 500);
                }else{
                    clearTimeout(ovTimeOut);
                    curr_obj.showoverlay = false;
                    document.cookie = "import_template=st; expires=Thu, 18 Dec 2013 12:00:00 UTC";
                    //alert('closing');
                }

            },
            uploadFile:function(event)
            {
                this.showoverlay = true;
                this.errormsg = [];
                this.empfile = event.target.files[0];
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.showoverlay = false;

                        this.$bvToast.toast('File uploaded.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });

                        //alert('Check this link to get the processed data: ' + this.uploaded_file_data);
                        window.location.href = this.uploaded_file_data;

                    }.bind(this)).
                    catch(function (error)
                            {
                                //alert(error.response.data.errors);
                            });
            },
        },
        created: function(){
            //this.setUrls();
        },

        computed:
        {

        }
    }
</script>
